import { render, staticRenderFns } from "./Tab3.vue?vue&type=template&id=daa713dc&scoped=true&"
import script from "./Tab3.vue?vue&type=script&lang=ts&"
export * from "./Tab3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa713dc",
  null
  
)

export default component.exports